module.exports = __webpack_public_path__ + "static/media/alert.4cff03bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/alert.svg
// module id = 515
// module chunks = 0